import apiConfig from '@/config/api-config'
import activityLogConfig from '@/config/activity-log-config'
import axiosHttp from '@/utilities/axios-http'

class ActivityLogService {
  resource
  resourcePath

  constructor(resource) {
    this.resource = resource
    this.resourcePath = `${apiConfig.API_BASE_URL}/${apiConfig.API_PATH}/${this.resource}`
  }

  dashboardActivityLogs = () => {
    return axiosHttp.get(
      `${this.resourcePath}/${activityLogConfig.DASHBOARD_PATH}`
    )
  }

  projectActivityLogs = project_id => {
    return axiosHttp.get(
      `${this.resourcePath}/${activityLogConfig.PROJECT_PATH}/${project_id}`
    )
  }
}

export default new ActivityLogService(activityLogConfig.API_RESOURCE)
